/* ============================================================
   PRODUCT.JS — Product Page Interactions
   - Image gallery with dot navigation
   - Size selector (updates variant ID)
   - Quantity stepper
   - Bundle & Save selector
   - Accordion open/close
   - Wishlist toggle
   - Share button
   ============================================================ */

(function () {
  'use strict';

  // -------------------------------------------------------
  // IMAGE GALLERY
  // -------------------------------------------------------
  const galleryMain = document.getElementById('ProductGalleryMain');
  const galleryDots = document.getElementById('ProductGalleryDots');

  if (galleryMain && galleryDots) {
    const slides = galleryMain.querySelectorAll('.product-gallery__slide');
    const dots   = galleryDots.querySelectorAll('.product-gallery__dot');
    const prevBtn = document.getElementById('GalleryPrev');
    const nextBtn = document.getElementById('GalleryNext');
    let currentSlide = 0;

    // Hide arrows if only 1 image
    if (slides.length <= 1) {
      galleryMain.setAttribute('data-single', 'true');
    }

    function goToSlide(index) {
      // Wrap around
      index = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      currentSlide = index;
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToSlide(i));
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentSlide - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentSlide + 1));

    // Swipe support on mobile
    let touchStartX = 0;

    galleryMain.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryMain.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        goToSlide(diff > 0 ? currentSlide + 1 : currentSlide - 1);
      }
    }, { passive: true });
  }


  // -------------------------------------------------------
  // SIZE SELECTOR
  // -------------------------------------------------------
  const sizeSelector = document.getElementById('SizeSelector');
  const variantIdInput = document.getElementById('VariantId');

  if (sizeSelector) {
    const sizeBtns = sizeSelector.querySelectorAll('.size-btn');

    sizeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        sizeBtns.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        // Update hidden variant ID for form submission
        const variantId = btn.dataset.variantId;
        if (variantId && variantIdInput) {
          variantIdInput.value = variantId;
        }
      });
    });
  }


  // -------------------------------------------------------
  // QUANTITY STEPPER
  // -------------------------------------------------------
  const qtyInput = document.getElementById('QtyInput');
  const qtyMinus = document.getElementById('QtyMinus');
  const qtyPlus  = document.getElementById('QtyPlus');
  const formQty  = document.getElementById('FormQuantity');

  function updateQty(val) {
    const min = parseInt(qtyInput.min) || 1;
    const max = parseInt(qtyInput.max) || 99;
    const newVal = Math.min(Math.max(val, min), max);
    qtyInput.value = newVal;
    if (formQty) formQty.value = newVal;

    // Disable minus at min
    if (qtyMinus) qtyMinus.disabled = newVal <= min;
  }

  if (qtyMinus) {
    qtyMinus.disabled = true; // starts at 1
    qtyMinus.addEventListener('click', () => {
      updateQty(parseInt(qtyInput.value) - 1);
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      updateQty(parseInt(qtyInput.value) + 1);
    });
  }


  // -------------------------------------------------------
  // BUNDLE SELECTOR
  // -------------------------------------------------------
  const bundleSelector = document.getElementById('BundleSelector');
  const productPrice   = document.getElementById('ProductPrice');

  if (bundleSelector) {
    const bundleOptions = bundleSelector.querySelectorAll('.bundle-option');

    bundleOptions.forEach((option) => {
      option.addEventListener('click', () => {
        bundleOptions.forEach((o) => o.classList.remove('is-selected'));
        option.classList.add('is-selected');

        // Update quantity
        const qty = parseInt(option.dataset.quantity) || 1;
        if (qtyInput) updateQty(qty);

        // Update displayed price
        const price = option.dataset.price;
        if (price && productPrice) {
          productPrice.textContent = '₹' + price;
        }
      });
    });
  }


  // -------------------------------------------------------
  // ACCORDIONS
  // -------------------------------------------------------
  const accordionTriggers = document.querySelectorAll('.accordion__trigger');

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const bodyId = 'Accordion' + capitalise(trigger.dataset.accordion) + 'Body';
      const body = document.getElementById(bodyId);

      // Close all
      accordionTriggers.forEach((t) => {
        t.setAttribute('aria-expanded', 'false');
        const bId = 'Accordion' + capitalise(t.dataset.accordion) + 'Body';
        const b = document.getElementById(bId);
        if (b) b.hidden = true;
      });

      // Open clicked (unless it was already open)
      if (!isOpen && body) {
        trigger.setAttribute('aria-expanded', 'true');
        body.hidden = false;
      }
    });
  });

  function capitalise(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }


  // -------------------------------------------------------
  // WISHLIST TOGGLE
  // -------------------------------------------------------
  const wishlistBtn = document.getElementById('WishlistBtn');

  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', () => {
      wishlistBtn.classList.toggle('is-wishlisted');
      const isWishlisted = wishlistBtn.classList.contains('is-wishlisted');
      wishlistBtn.setAttribute('aria-label', isWishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }


  // -------------------------------------------------------
  // SHARE BUTTON — Web Share API with fallback copy
  // -------------------------------------------------------
  const shareBtn = document.getElementById('ShareBtn');

  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const shareData = {
        title: document.title,
        url: window.location.href,
      };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
        } catch (err) {
          // User cancelled — no action needed
        }
      } else {
        // Fallback: copy URL to clipboard
        try {
          await navigator.clipboard.writeText(window.location.href);
          const original = shareBtn.innerHTML;
          shareBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          setTimeout(() => { shareBtn.innerHTML = original; }, 1500);
        } catch (err) {
          console.warn('Copy failed', err);
        }
      }
    });
  }


  // SIZE GUIDE MODAL
  const sizeGuideTrigger=document.getElementById('SizeGuideTrigger');
  const sizeGuideModal=document.getElementById('SizeGuideModal');
  const sizeGuideClose=document.getElementById('SizeGuideClose');
  if(sizeGuideTrigger&&sizeGuideModal){
    sizeGuideTrigger.addEventListener('click',()=>sizeGuideModal.hidden=false);
    if(sizeGuideClose){sizeGuideClose.addEventListener('click',()=>sizeGuideModal.hidden=true);}
    const overlay=sizeGuideModal.querySelector('.size-guide-modal__overlay');
    if(overlay){overlay.addEventListener('click',()=>sizeGuideModal.hidden=true);}
  }

})();
